<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardHeader>
                                <CCol md="1">
                                    <ButtonBack class="mr-3" title="Go back" />
                                </CCol>
                            </CCardHeader>
                            <CCardBody>
                                <CContainer fluid class="p-0">
                                    <CRow alignHorizontal="center">
                                        <CCol md="10" sm="12">
                                            <CCard>
                                                <CCardHeader>
                                                    <h5 class="mb-0">
                                                        {{
                                                            $t(
                                                                "configure_import"
                                                            )
                                                        }}
                                                    </h5>
                                                    <p class="mb-0">
                                                        {{
                                                            $t(
                                                                "configure_import_description"
                                                            )
                                                        }}
                                                    </p>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CContainer>
                                                        <CRow>
                                                            <CCol>
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "format"
                                                                        )
                                                                    }}
                                                                </label>
                                                                <CSelect
                                                                    :options="[
                                                                        {
                                                                            value: 'csv',
                                                                            label: $t(
                                                                                'csv'
                                                                            ),
                                                                        },
                                                                    ]"
                                                                    size="sm"
                                                                    class="font-weight-bold"
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'import',
                                                                                field_name:
                                                                                    'format',
                                                                            }
                                                                        )
                                                                    "
                                                                    :value.sync="
                                                                        $v.forms
                                                                            .import
                                                                            .format
                                                                            .$model
                                                                    "
                                                                />
                                                            </CCol>
                                                            <CCol>
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "delimiter"
                                                                        )
                                                                    }}
                                                                </label>
                                                                <CSelect
                                                                    :options="[
                                                                        {
                                                                            value: ',',
                                                                            label: ',',
                                                                        },
                                                                        {
                                                                            value: ';',
                                                                            label: ';',
                                                                        },
                                                                        {
                                                                            value: ' ',
                                                                            label: $t(
                                                                                'space'
                                                                            ),
                                                                        },
                                                                    ]"
                                                                    size="sm"
                                                                    class="font-weight-bold"
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'import',
                                                                                field_name:
                                                                                    'delimiter',
                                                                            }
                                                                        )
                                                                    "
                                                                    :value.sync="
                                                                        $v.forms
                                                                            .import
                                                                            .delimiter
                                                                            .$model
                                                                    "
                                                                />
                                                            </CCol>
                                                            <CCol>
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "quote"
                                                                        )
                                                                    }}
                                                                </label>
                                                                <CSelect
                                                                    :options="[
                                                                        {
                                                                            value: '',
                                                                            label: 'Without quote',
                                                                        },
                                                                        {
                                                                            value: 'quote',
                                                                            label: 'Quote',
                                                                        },
                                                                        {
                                                                            value: 'double_quote',
                                                                            label: 'Double quote',
                                                                        },
                                                                    ]"
                                                                    size="sm"
                                                                    class="font-weight-bold"
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'import',
                                                                                field_name:
                                                                                    'delimiter',
                                                                            }
                                                                        )
                                                                    "
                                                                    :value.sync="
                                                                        $v.forms
                                                                            .import
                                                                            .quote
                                                                            .$model
                                                                    "
                                                                />
                                                            </CCol>
                                                            <CCol>
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "end_line"
                                                                        )
                                                                    }}
                                                                </label>
                                                                <CSelect
                                                                    :options="[
                                                                        {
                                                                            value: '\n',
                                                                            label: '\\n',
                                                                        },
                                                                        {
                                                                            value: '\r\n',
                                                                            label: '\\r\\n',
                                                                        },
                                                                    ]"
                                                                    class="font-weight-bold"
                                                                    size="sm"
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'import',
                                                                                field_name:
                                                                                    'endLine',
                                                                            }
                                                                        )
                                                                    "
                                                                    :value.sync="
                                                                        $v.forms
                                                                            .import
                                                                            .endLine
                                                                            .$model
                                                                    "
                                                                />
                                                            </CCol>
                                                        </CRow>

                                                        <CRow>
                                                            <CCol sm="4">
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "input"
                                                                        )
                                                                    }}
                                                                </label>
                                                                <p class="mb-0">
                                                                    {{
                                                                        $t(
                                                                            "input_description"
                                                                        )
                                                                    }}
                                                                </p>
                                                                <SelectAsync
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'import',
                                                                                field_name:
                                                                                    'provider',
                                                                            }
                                                                        )
                                                                    "
                                                                    :value.sync="
                                                                        $v.forms
                                                                            .import
                                                                            .provider
                                                                            .$model
                                                                    "
                                                                    :placeholder="
                                                                        $t(
                                                                            'select_an_option'
                                                                        )
                                                                    "
                                                                    :invalidFeedback="
                                                                        $t(
                                                                            'input_is_required'
                                                                        )
                                                                    "
                                                                    size="sm"
                                                                    :optionsValue="'id'"
                                                                    :optionsLabel="'name'"
                                                                    :endpoint="'provider'"
                                                                />
                                                            </CCol>
                                                            <CCol
                                                                v-if="
                                                                    providerInfo
                                                                "
                                                                class="lg-container"
                                                            >
                                                                <div
                                                                    class="lg-aling-buttom input-fields"
                                                                >
                                                                    <div>
                                                                        {{
                                                                            $t(
                                                                                "this_input_needs_these_fields"
                                                                            )
                                                                        }}:
                                                                    </div>
                                                                    <div>
                                                                        <span
                                                                            v-for="(
                                                                                item,
                                                                                index
                                                                            ) in providerInfo.fields"
                                                                            :key="
                                                                                index
                                                                            "
                                                                        >
                                                                            {{
                                                                                item.mapping
                                                                                    ? item.mapping
                                                                                    : item.name
                                                                            }}
                                                                            {{
                                                                                item.required
                                                                                    ? ""
                                                                                    : "(" +
                                                                                      $t(
                                                                                          "optional"
                                                                                      ) +
                                                                                      ")"
                                                                            }}
                                                                            {{
                                                                                hasNextItem(
                                                                                    {
                                                                                        index,
                                                                                        array: providerInfo.fields,
                                                                                    }
                                                                                )
                                                                                    ? ","
                                                                                    : ""
                                                                            }}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </CCol>
                                                        </CRow>
                                                        <CRow
                                                            v-if="
                                                                optionsSelectForms.length >
                                                                0
                                                            "
                                                        >
                                                            <CCol sm="4">
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "Form"
                                                                        )
                                                                    }}
                                                                </label>
                                                                <p class="mb-0">
                                                                    {{
                                                                        $t(
                                                                            "forms_description"
                                                                        )
                                                                    }}
                                                                </p>
                                                                <CSelect
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'import',
                                                                                field_name:
                                                                                    'formKey',
                                                                            }
                                                                        )
                                                                    "
                                                                    :value.sync="
                                                                        $v.forms
                                                                            .import
                                                                            .form
                                                                            .$model
                                                                    "
                                                                    :options="
                                                                        optionsSelectForms
                                                                    "
                                                                    :placeholder="
                                                                        $t(
                                                                            'select_an_option'
                                                                        )
                                                                    "
                                                                    size="sm"
                                                                />
                                                            </CCol>
                                                        </CRow>
                                                        <CRow
                                                            v-if="
                                                                optionsSelectSponsors.length >
                                                                0
                                                            "
                                                        >
                                                            <CCol sm="4">
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "Sponsors"
                                                                        )
                                                                    }}</label
                                                                >
                                                                <p class="mb-0">
                                                                    {{
                                                                        $t(
                                                                            "search_list_description"
                                                                        )
                                                                    }}.
                                                                </p>
                                                                <SelectTags
                                                                    :placeholder="
                                                                        $t(
                                                                            'search_list'
                                                                        )
                                                                    "
                                                                    size="sm"
                                                                    :value.sync="
                                                                        forms
                                                                            .import
                                                                            .sponsors
                                                                    "
                                                                    :options="
                                                                        optionsSelectSponsors
                                                                    "
                                                                />
                                                            </CCol>
                                                        </CRow>
                                                        <CRow>
                                                            <CCol md="12">
                                                                <CInputCheckbox
                                                                    :checked.sync="
                                                                        $v.forms
                                                                            .import
                                                                            .acceptedPolicies
                                                                            .$model
                                                                    "
                                                                    :label="
                                                                        $t(
                                                                            'i_confirm_that_all_subscribers_uploaded_gave_clear_consent_to_the_management_of_their_information_by_my_company'
                                                                        )
                                                                    "
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'import',
                                                                                field_name:
                                                                                    'acceptedPolicies',
                                                                            }
                                                                        )
                                                                    "
                                                                    :invalidFeedback="
                                                                        $t(
                                                                            'it_is_necessary_to_accept_the_policies'
                                                                        )
                                                                    "
                                                                />
                                                            </CCol>
                                                        </CRow>
                                                        <CRow class="mt-2">
                                                            <CCol md="12">
                                                                <h6
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "Disable delivery"
                                                                        )
                                                                    }}
                                                                </h6>
                                                                <p>
                                                                    When enabled this option, imported records will not be sent to any Delivery Campaign. <br>
                                                                    If left disabled, the delivery flow will be respected.
                                                                </p>
                                                            </CCol>
                                                            <CCol md="12">
                                                                <CCSwitch
                                                                    :checked.sync="
                                                                        $v.forms
                                                                            .import
                                                                            .disableDelivery
                                                                            .$model
                                                                    "
                                                                    :label="
                                                                        $t(
                                                                            'Disable' + ':'
                                                                        )
                                                                    "
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'import',
                                                                                field_name:
                                                                                    'disableDelivery',
                                                                            }
                                                                        )
                                                                    "
                                                                    :horizontal="{
                                                                        label: 'col-1',
                                                                        input: 'col-11',
                                                                    }"
                                                                    
                                                                    color="primary"
                                                                    shape="pill"
                                                                    variant="3d"
                                                                />
                                                            </CCol>
                                                        </CRow>
                                                    </CContainer>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                    <CRow alignHorizontal="center">
                                        <CCol md="10" sm="12">
                                            <CAlert
                                                color="warning"
                                                v-if="hasLeadId"
                                                closeButton
                                            >
                                                {{
                                                    $t(
                                                        "import_update_alert_description"
                                                    )
                                                }}
                                            </CAlert>
                                        </CCol>
                                    </CRow>

                                    <CRow alignHorizontal="center">
                                        <CCol md="10" sm="12">
                                            <h5>{{ $t("file_fields") }}</h5>
                                            <p class="mb-0">
                                                {{
                                                    $t(
                                                        "file_fields_description"
                                                    )
                                                }}.
                                            </p>
                                            <CDataTable
                                                :items="
                                                    tables.fieldMapping.items
                                                "
                                                :fields="
                                                    traslateLabels(
                                                        tables.fieldMapping
                                                            .fields
                                                    )
                                                "
                                                hover
                                                border
                                                striped
                                            >
                                                <template #no-items-view>
                                                    <div
                                                        class="block-no-items section"
                                                    >
                                                        <h2
                                                            class="section__title text-no-items"
                                                        >
                                                            {{
                                                                $t(
                                                                    "select_file_export"
                                                                )
                                                            }}
                                                        </h2>
                                                        <CInputFile
                                                            :placeholder="
                                                                $t(
                                                                    'upload_file'
                                                                )
                                                            "
                                                            @change="importFile"
                                                            :isValid="
                                                                checkIfFormValid(
                                                                    {
                                                                        form_name:
                                                                            'import',
                                                                        field_name:
                                                                            'file',
                                                                    }
                                                                )
                                                            "
                                                        />
                                                    </div>
                                                </template>
                                                <template #over-table>
                                                    <CInputFile
                                                        :placeholder="
                                                            $t('upload_file')
                                                        "
                                                        @change="importFile"
                                                        v-if="
                                                            tables.fieldMapping
                                                                .items.length >
                                                            0
                                                        "
                                                        :isValid="
                                                            checkIfFormValid({
                                                                form_name:
                                                                    'import',
                                                                field_name:
                                                                    'file',
                                                            })
                                                        "
                                                    />
                                                </template>
                                                <template #order="{ index }">
                                                    <td>
                                                        {{ index + 1 }}
                                                    </td>
                                                </template>
                                                <template
                                                    #mappingName="{ index }"
                                                >
                                                    <td>
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    {
                                                                        table_name:
                                                                            'fieldMapping',
                                                                        index,
                                                                        field_name:
                                                                            'mappingName',
                                                                    }
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables
                                                                    .fieldMapping
                                                                    .items.$each
                                                                    .$iter[
                                                                    index
                                                                ].mappingName
                                                                    .$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_the_mapping'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </td>
                                                </template>
                                            </CDataTable>
                                        </CCol>
                                        <CCol md="10" sm="12">
                                            <h5>{{ $t("fixed_fields") }}</h5>
                                            <p class="mb-0">
                                                {{
                                                    $t(
                                                        "you_can_create_fixed_fields_for_your_import,_These_fields_will_be_added_to_the_import_file"
                                                    )
                                                }}.
                                            </p>
                                            <CDataTable
                                                :items="
                                                    tables.fixedFields.items
                                                "
                                                :fields="
                                                    traslateLabels(
                                                        tables.fixedFields
                                                            .fields
                                                    )
                                                "
                                                hover
                                                border
                                                striped
                                            >
                                                <template #no-items-view>
                                                    <div
                                                        class="block-no-items section"
                                                    >
                                                        <h2
                                                            class="section__title text-no-items"
                                                        >
                                                            {{
                                                                $t(
                                                                    "add_fixed_field"
                                                                )
                                                            }}
                                                        </h2>
                                                        <CButton
                                                            color="success"
                                                            class="button m-2 shadow"
                                                            :title="
                                                                $t(
                                                                    'add_fixed_field'
                                                                )
                                                            "
                                                            @click="
                                                                addItemToTable(
                                                                    'fixedFields'
                                                                )
                                                            "
                                                        >
                                                            <span
                                                                class="button__icon"
                                                            >
                                                                <CIcon
                                                                    :content="
                                                                        $options
                                                                            .icons
                                                                            .cilPlus
                                                                    "
                                                                />
                                                            </span>
                                                            <span
                                                                class="button__text"
                                                            >
                                                                {{
                                                                    $t(
                                                                        "add_fixed_field"
                                                                    )
                                                                }}
                                                            </span>
                                                        </CButton>
                                                    </div>
                                                </template>
                                                <template #under-table>
                                                    <CButton
                                                        color="success"
                                                        class="button m-2 shadow"
                                                        @click="
                                                            addItemToTable(
                                                                'fixedFields'
                                                            )
                                                        "
                                                        v-if="
                                                            tables.fixedFields
                                                                .items.length >
                                                            0
                                                        "
                                                    >
                                                        <span
                                                            class="button__icon"
                                                        >
                                                            <CIcon
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cilPlus
                                                                "
                                                            />
                                                        </span>
                                                        <span
                                                            class="button__text"
                                                        >
                                                            {{
                                                                $t(
                                                                    "add_fixed_field"
                                                                )
                                                            }}
                                                        </span>
                                                    </CButton>
                                                </template>
                                                <template #name="{ index }">
                                                    <td>
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    {
                                                                        table_name:
                                                                            'fixedFields',
                                                                        index,
                                                                        field_name:
                                                                            'name',
                                                                    }
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables
                                                                    .fixedFields
                                                                    .items.$each
                                                                    .$iter[
                                                                    index
                                                                ].name.$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_file_name'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </td>
                                                </template>
                                                <template #value="{ index }">
                                                    <td>
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormTableValid(
                                                                    {
                                                                        table_name:
                                                                            'fixedFields',
                                                                        index,
                                                                        field_name:
                                                                            'value',
                                                                    }
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.tables
                                                                    .fixedFields
                                                                    .items.$each
                                                                    .$iter[
                                                                    index
                                                                ].value.$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'enter_file_value'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </td>
                                                </template>
                                                <template #options="{ index }">
                                                    <td
                                                        class="py-2 text-center"
                                                    >
                                                        <CButton
                                                            color="danger"
                                                            variant="outline"
                                                            square
                                                            size="sm"
                                                            @click="
                                                                deleteItemToTable(
                                                                    'fixedFields',
                                                                    index
                                                                )
                                                            "
                                                        >
                                                            <CIcon
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cilTrash
                                                                "
                                                            />
                                                        </CButton>
                                                    </td>
                                                </template>
                                            </CDataTable>
                                        </CCol>
                                    </CRow>
                                    <CRow alignHorizontal="center">
                                        <CCol
                                            class="d-flex justify-content-end"
                                            md="10"
                                            sm="12"
                                        >
                                            <CButton
                                                class="button shadow create-button"
                                                :title="$t('start_import_data')"
                                                @click="sendForm()"
                                                :disabled="
                                                    forms.import._loading
                                                "
                                            >
                                                <span
                                                    class="button__icon text-white-50"
                                                >
                                                    <CSpinner
                                                        class="mr-1"
                                                        color="light"
                                                        size="sm"
                                                        v-if="
                                                            forms.import
                                                                ._loading
                                                        "
                                                    />
                                                    <CIcon
                                                        v-else
                                                        :content="
                                                            $options.icons
                                                                .cilPlus
                                                        "
                                                    />
                                                </span>
                                                <span class="button__text">
                                                    {{ $t("import_data") }}
                                                </span>
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
import SelectAsync from "£lement/SelectAsync";
import SelectTags from "£lement/SelectTags";
import ButtonBack from "£lement/ButtonBack";
import CCSwitch from "~/components/CCSwitch.vue";
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { cilTrash, cilArrowBottom, cilArrowTop, cilPlus } from "@coreui/icons";
import { mapGetters } from "vuex";
import axios from "axios";
import { CCol } from "@coreui/vue";

const isTrue = (value) => {
    return value === true ? true : false;
};

export default {
    name: "ImportConfigPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, validationMixin, tableMixin],

    icons: {
        cilTrash,
        cilArrowTop,
        cilArrowBottom,
        cilPlus,
    },

    components: {
        SelectAsync,
        ButtonBack,
        SelectTags,
        CCSwitch,
    },
    data() {
        return {
            forms: {
                import: {
                    file: null,
                    provider: null,
                    appId: null,
                    apiKey: null,
                    form: null,
                    formKey: null,
                    format: "csv",
                    delimiter: ",",
                    quote: '"',
                    endLine: "\n",
                    fieldMapping: [],
                    fixedFields: [],
                    sponsors: [],
                    acceptedPolicies: false,
                    disableDelivery: false,
                    _loading: false,
                },
            },
            tables: {
                fieldMapping: {
                    fields: [
                        {
                            key: "order",
                            label: "#",
                        },
                        {
                            key: "columnName",
                            label: "column_name",
                        },
                        {
                            key: "mappingName",
                            label: "mapping_name",
                        },
                    ],
                    items: [],
                },
                fixedFields: {
                    fields: [
                        {
                            key: "name",
                            label: "field_name",
                        },
                        {
                            key: "value",
                            label: "field_value",
                        },
                        {
                            key: "options",
                            label: "options",
                        },
                    ],
                    items: [],
                },
            },
            providerInfo: null,
            formInfo: null,
            listForms: null,
            listSponsors: null,
            hasLeadId: false,
        };
    },
    computed: {
        ...mapGetters({
            storeGlobalAppId: "auth/appId",
        }),
        tableFieldMappingItems() {
            return this.tables.fieldMapping.items;
        },
        optionsSelectForms() {
            let options = [];
            if (this.listForms) {
                options = this.listForms.map((item) => {
                    return {
                        label: item.name,
                        value: item.uuid,
                    };
                });
            }
            return options;
        },
        optionsSelectSponsors() {
            let options = [];
            if (this.listSponsors) {
                options = this.listSponsors.map((item) => {
                    return {
                        name: item.CampaignName,
                        value: `${item.CampaignId}`,
                    };
                });
            }

            return options;
        },
    },
    watch: {
        storeGlobalAppId(newValue, oldValue) {
            this.forms.import.appId = newValue;
        },
        tableFieldMappingItems(newValue, oldValue) {
            this.forms.import.fieldMapping = newValue;
            let find = newValue.find((item) => {
                return (
                    item.columnName === "lead_id" ||
                    item.mappingName === "lead_id"
                );
            });
            this.hasLeadId = find ? true : false;
        },
        "tables.fixedFields.items": {
            handler: async function (newValue, oldValue) {
                this.forms.import.fixedFields = newValue;
                let find = newValue.find((item) => {
                    return item.name === "lead_id";
                });
                this.hasLeadId = find ? true : false;
            },
            deep: true,
        },
        "forms.import.provider": {
            handler: async function (newValue, oldValue) {
                await this.loadProviderInfo();
                await this.loadListForms();
            },
            deep: true,
        },
        "forms.import.form": {
            handler: async function (newValue, oldValue) {
                await this.loadFormInfo();
                await this.loadListSponsors();
            },
            deep: true,
        },
        "forms.import.delimiter": {
            handler: async function (newValue, oldValue) {
                this.importFile([this.forms.import.file]);
            },
        },
        "forms.import.quote": {
            handler: async function (newValue, oldValue) {
                this.importFile([this.forms.import.file]);
            },
        },
    },
    validations: {
        forms: {
            import: {
                file: {
                    required,
                },
                provider: {
                    required,
                },
                appId: {
                    required,
                },
                apiKey: {
                    required,
                },
                form: {},
                formKey: {},
                format: {
                    required,
                },
                delimiter: {
                    // required
                },
                quote: {},
                endLine: {
                    // required
                },
                acceptedPolicies: {
                    required,
                    isTrue,
                },
                disableDelivery: {},
            },
        },
        tables: {
            fieldMapping: {
                items: {
                    $each: {
                        columnName: {
                            required,
                        },
                        mappingName: {},
                    },
                },
            },
            fixedFields: {
                items: {
                    $each: {
                        name: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
        },
    },

    methods: {
        async sendData() {
            let formData = new FormData();
            let file = this.forms.import.file;
            let config = {
                ...this.forms.import,
            };
            delete config.file;
            delete config._loading;

            formData.append("Storage", file);
            formData.append("Config", JSON.stringify(config));
            let response = await axios.post("import.api/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return response.data;
        },

        async sendForm() {
            try {
                this.updatePageLoading(true);
                let isValid = true;
                let formValidation = this.$v.forms["import"];
                formValidation.$touch();
                if (formValidation.$invalid) {
                    isValid = false;
                }

                let fieldMappingValidation = this.$v.tables["fieldMapping"];
                fieldMappingValidation.$touch();
                if (fieldMappingValidation.$invalid) {
                    isValid = false;
                }
                if (!isValid) {
                    throw {
                        code: 422,
                        message: this.$t("invalid_data"),
                    };
                }

                this.forms.import._loading = true;

                let data = await this.sendData();

                if (data.success == true) {
                    this.$store.dispatch("toast/addFixedToasts", {
                        header: "¡_import!",
                        body: "imported_successfully",
                        color: "success",
                    });
                    this.$router.push({ name: "imports" });
                }
                this.forms.import._loading = false;
                this.$router.push({
                    name: "imports",
                });
            } catch (error) {
                this.showMessageError(error);
                this.forms.import._loading = false;
            }

            this.updatePageLoading(false);
        },
        async loadProviderInfo() {
            let provider = await this.fetcher({
                url: `/provider/${this.forms.import.provider}`,
            });
            this.providerInfo = provider;
            let response = await this.fetcher({
                url: `/input.api/providers/${this.providerInfo.uuid}/fields`,
            });
            let providerFields = response._items;
            // let providerFields = await this.fetcher({
            //     url:'/provider_field',
            //     query: {
            //         query:{
            //             where:{
            //                 Provider:{
            //                     uuid:this.providerInfo.uuid
            //                 }
            //             }
            //         }
            //     }
            // });
            providerFields = providerFields.map((item) => {
                let findField = this.storeGlobalFieldsAdvance.find((field) => {
                    return field.id == item.field_id;
                });
                return {
                    ...item,
                    name: findField.name,
                };
            });

            this.providerInfo = {
                ...this.providerInfo,
                fields: providerFields,
            };
            this.forms.import.apiKey = this.providerInfo.api_key;
        },
        async loadListForms() {
            let listForms = await this.fetcher({
                url: "/form",
                query: {
                    query: {
                        where: {
                            provider_id: this.providerInfo.id,
                        },
                    },
                },
            });
            this.listForms = listForms;
        },
        async loadFormInfo() {
            let formInfo = await this.fetcher({
                url: "/form/" + this.forms.import.form,
            });
            this.formInfo = formInfo;
            this.forms.import.formKey = this.formInfo.api_key;
        },
        async loadListSponsors() {
            let listSponsors = await this.fetcher({
                url: "/getSponsorByForm/" + this.formInfo.uuid,
            });

            this.listSponsors = listSponsors;
        },
        importFile(file, event) {
            try {
                if (file[0]) {
                    if (file[0].name.includes(".csv")) {
                        var r = new FileReader();
                        r.onload = this.readFile;
                        r.readAsText(file[0]);
                        this.forms.import.file = file[0];
                    } else {
                        throw "El archivo debe ser CSV";
                    }
                }
            } catch (error) {
                this.showMessageError(error);
            }
        },

        readFile(e) {
            var contents = e.target.result;
            var lines = contents.split("\n");
            let lineHeader = lines[0];
            /* Remove endline */
            lineHeader = lineHeader.replace(/\r/g, "");

            /**Remove quotes */
            switch (this.forms.import.quote) {
                case "quote":
                    lineHeader = lineHeader.replaceAll("'", "");
                    break;
                case "double_quote":
                    lineHeader = lineHeader.replaceAll('"', "");
                    break;
                default:
                    break;
            }
            let headers = lineHeader.split(this.forms.import.delimiter);
            this.tables.fieldMapping.items = [];
            for (let i = 0; i < headers.length; i++) {
                let header = headers[i];
                let item = {
                    columnName: header,
                    mappingName: null,
                };
                this.tables.fieldMapping.items.push(item);
            }
        },
    },
    mounted() {
        this.forms.import.appId = this.storeGlobalAppId;
        this.updatePageLoading(false);
        this.loadFieldsAdvance();
    },
};
</script>

<style lang="scss" scoped>
.input-fields {
    margin-bottom: 1rem;
}
</style>
